import React from 'react';
import { Box, CircularProgress, Fade } from '@mui/material';
import { alpha } from '@mui/material/styles';

/**
 * Visual indicator for pending operations on tasks
 * Shows a subtle overlay with loading spinner
 */
const PendingOperationIndicator = ({ isPending, children }) => {
  return (
    <Box position="relative">
      {children}
      <Fade in={isPending} timeout={200}>
        <Box
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{
            backgroundColor: (theme) => alpha(theme.palette.background.paper, 0.7),
            zIndex: 1,
            borderRadius: 'inherit',
            pointerEvents: isPending ? 'auto' : 'none',
          }}
        >
          <CircularProgress size={20} thickness={3} />
        </Box>
      </Fade>
    </Box>
  );
};

export default PendingOperationIndicator;